import React, { useState, useEffect } from "react";
import { BillingService } from "../../services/BillingService";
import { usePermissions } from "../../PermissionsProvider";
import { ModelCost } from "../../model_gen/billing";
import ModelPricingTable from "./ModelPricingTable";

const ModelPricing: React.FC = () => {
  const [modelPricing, setModelPricing] = useState<ModelCost[]>([]);
  const [loading, setLoading] = useState(true);
  const { apiKey } = usePermissions();

  useEffect(() => {
    BillingService.getPricing(setLoading, apiKey).subscribe(
      (data: ModelCost[]) => {
        setModelPricing(data);
        setLoading(false);
      },
      (error: any) => {
        console.error("Error fetching model pricing:", error);
        setLoading(false);
      }
    );
  }, [apiKey]);

  return (
    <ModelPricingTable
      modelPricing={modelPricing}
      loading={loading}
      emptyTitle="No pricing data available"
      emptyDescription="Model pricing information could not be loaded."
    />
  );
};

export default ModelPricing;
